import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const MentionsLegales = () => {
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Header />
      <main className="flex-1 pt-28 pb-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 space-y-10">
          <header className="space-y-4 text-center">
            <h1 className="text-3xl md:text-4xl font-bold text-gray-900">Mentions légales</h1>
            <p className="text-gray-600 text-lg">Dernière mise à jour : {new Date().toLocaleDateString('fr-FR')}</p>
          </header>

          <section className="space-y-6 text-gray-700 leading-relaxed">
            <h2 className="text-2xl font-semibold text-gray-900">1. Éditeur du site</h2>
            <p>
              Dénomination / Nom : <strong>CTB28</strong><br />
              Statut juridique : (à compléter)<br />
              Adresse : (à compléter) – Eure-et-Loir (28) / Essonne (91) / Loiret (45)<br />
              Email : contact@ctb28.fr<br />
              Téléphone : 06 12 34 56 78
            </p>

            <h2 className="text-2xl font-semibold text-gray-900">2. Directeur de la publication</h2>
            <p>Le responsable de la publication est : (Nom, fonction).</p>

            <h2 className="text-2xl font-semibold text-gray-900">3. Hébergement</h2>
            <p>
              Hébergeur : (Fournisseur – ex: OVH, Scaleway ...)<br />
              Adresse : (Adresse de l'hébergeur)<br />
              Site web : (URL de l'hébergeur)<br />
              Téléphone : (si nécessaire)
            </p>

            <h2 className="text-2xl font-semibold text-gray-900">4. Propriété intellectuelle</h2>
            <p>
              L'ensemble des éléments du site (textes, images, logos, structure, design) sont protégés par le droit de la propriété intellectuelle. Toute reproduction non autorisée est interdite.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900">5. Responsabilité</h2>
            <p>
              Les informations fournies sur ce site ont une valeur informative. Malgré le soin apporté à leur exactitude, aucune garantie n'est donnée. L'éditeur ne peut être tenu responsable d'une mauvaise interprétation ou d'un usage inapproprié.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900">6. Liens externes</h2>
            <p>
              Des liens peuvent rediriger vers des sites tiers. L'éditeur n'exerce aucun contrôle sur leur contenu et décline toute responsabilité quant à leur disponibilité ou exactitude.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900">7. Données personnelles</h2>
            <p>
              Le traitement des données personnelles est détaillé dans la <a href="/politique-confidentialite" target="_blank" rel="noopener noreferrer" className="text-blue-900 underline">Politique de confidentialité</a>.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900">8. Contact</h2>
            <p>Pour toute question : contact@ctb28.fr</p>

            <p className="text-sm text-gray-500">(Remplacer les zones à compléter par les informations légales définitives avant mise en production.)</p>
          </section>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default MentionsLegales;
